import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  FaFileAlt, 
  FaMoneyBillWave, 
  FaBuilding, 
  FaUsers, 
  FaMale, 
  FaFemale, 
  FaMapMarkerAlt, 
  FaUserTie, 
  FaPhone, 
  FaWater, 
  FaTools, 
  FaShieldAlt, 
  FaSeedling, 
  FaHeartbeat, 
  FaUserMd, 
  FaGraduationCap, 
  FaChild, 
  FaHandsHelping,
  FaHome
} from 'react-icons/fa';
import { translations } from '../i18n';
import FAQ from '../components/FAQ';

function Home({ language }) {
  const t = translations[language];
  const [currentSlide, setCurrentSlide] = useState(0);
  const heroImages = ['/img/3.jpeg', '/img/4.jpeg'];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000); // 5 seconds interval
    return () => clearInterval(interval);
  }, [heroImages.length]);

  const galleryImages = Array.from({ length: 22 }, (_, i) => `/img/${i + 1}.jpeg`);

  const stats = [
    { number: '१०८०', label: 'एकूण लोकसंख्या', color: '#3498db', icon: <FaUsers /> },
    { number: '५३८', label: 'पुरुष लोकसंख्या', color: '#2980b9', icon: <FaMale /> },
    { number: '५४२', label: 'महिला लोकसंख्या', color: '#e91e63', icon: <FaFemale /> },
  ];

  const nearbyVillages = [
    { name: 'डोळहारा', icon: <FaMapMarkerAlt />, color: '#3498db' },
    { name: 'सय्यद', icon: <FaMapMarkerAlt />, color: '#2ecc71' },
    { name: 'आदोशी', icon: <FaMapMarkerAlt />, color: '#f39c12' },
    { name: 'खोडाळा', icon: <FaMapMarkerAlt />, color: '#9b59b6' },
  ];

  const gramPanchayatStaff = [
    { name: 'श्रीमती. वैशाली बापू गोसावी', position: 'ग्रामपंचायत अधिकारी', phone: '9272330968', icon: <FaUserTie />, color: '#3498db' },
    { name: 'श्री. भरत लक्ष्मण थळेकर', position: 'जलपुरवठा कर्मचारी', phone: '7038105309', icon: <FaWater />, color: '#2ecc71' },
    { name: 'श्री. हिरामण अमृत हडोंगा', position: 'शिपाई', phone: '7620135257', icon: <FaTools />, color: '#f39c12' },
  ];

  const revenueStaff = [
    { name: 'श्री. प्रणय कांसारा', position: 'तलाठी', phone: '9970239090', icon: <FaFileAlt />, color: '#e74c3c' },
    { name: 'श्री. पांडुरंग मंगा हडोंगा', position: 'पोलीस पाटील', phone: '9130006309', icon: <FaShieldAlt />, color: '#34495e' },
    { name: 'श्री. आर. आर. पाटील', position: 'BLO अधिकारी (नाशेरा)', phone: '9309132101', icon: <FaUserTie />, color: '#9b59b6' },
    { name: 'श्री. दीपक कोळहे', position: 'कृषी अधिकारी', phone: '9422470208', icon: <FaSeedling />, color: '#27ae60' },
  ];

  const healthStaff = [
    { name: 'श्री. भाऊसाहेब चत्तर', position: 'तालुका वैद्यकीय अधिकारी', phone: '9665452868', icon: <FaUserMd />, color: '#e74c3c' },
    { name: 'श्री. अभिजीत घोकले', position: 'वैद्यकीय कर्मचारी', phone: '8767849361', icon: <FaHeartbeat />, color: '#3498db' },
    { name: 'श्रीमती. मीनाक्षी दिवाकर मुळे', position: 'ANM (आरोग्य कर्मचारी)', phone: '7030433176', icon: <FaHeartbeat />, color: '#e91e63' },
    { name: 'श्री. कृष्णा शंकर हमारे', position: 'आरोग्य कर्मचारी', phone: '8007471430', icon: <FaHeartbeat />, color: '#2ecc71' },
    { name: 'श्रीमती. मेघा योगेश सालवे', position: 'आशा कर्मचारी', phone: '9309459718', icon: <FaHandsHelping />, color: '#f39c12' },
    { name: 'श्रीमती. चांगुणा मुकुंद खांडवी', position: 'आशा कर्मचारी', phone: '9322435905', icon: <FaHandsHelping />, color: '#9b59b6' },
  ];

  const educationData = [
    { name: 'जिल्हा परिषद शाळा, नाशेरा', boys: 65, girls: 65, total: 130, icon: <FaGraduationCap />, color: '#3498db' },
    { name: 'जिल्हा परिषद शाळा, थावळवाडा', boys: 22, girls: 24, total: 46, icon: <FaGraduationCap />, color: '#2ecc71' },
  ];

  const anganwadiData = [
    { name: 'अंगणवाडी केंद्र – नाशेरा', boys: 49, girls: 46, total: 95, icon: <FaChild />, color: '#f39c12' },
    { name: 'अंगणवाडी केंद्र – थावळवाडा', boys: 26, girls: 24, total: 50, icon: <FaChild />, color: '#e91e63' },
  ];

  const selfHelpGroups = [
    'आदर्श', 'भारतमाता', 'भिंगरी', 'गावदेवी', 'जीवदानी', 'कुलस्वामिनी',
    'श्री महालक्ष्मी', 'तुळजाभवानी', 'महालक्ष्मी', 'महिला शक्ती', 'राधिका',
    'समर्थ', 'सावित्रीबाई फुले', 'श्री गणेश', 'श्रीराम समर्थ', 'वनिदेवी',
    'मोगरा', 'अबोली'
  ];

  const keyOfficials = [
    {
      name: 'श्री. देवेंद्र फडणवीस',
      position: 'मा. मुख्यमंत्री',
      image: '/person/देवेंद्र फडणवीस.jpg'
    },
    {
      name: 'श्री. एकनाथ शिंदे',
      position: 'मा. उपमुख्यमंत्री',
      image: '/person/एकनाथ शिंदे.jpg'
    },
    {
      name: 'सौ. सुनेत्रा अजित पवार',
      position: 'मा. उपमुख्यमंत्री',
      image: '/person/सुनेत्रा अजित पवार.jfif'
    },
    {
      name: 'श्री. जयकुमार गोरे',
      position: 'मा. मंत्री, ग्रामविकास व पंचायतराज',
      image: '/person/जयकुमार गोरे.png'
    },
    {
      name: 'श्री. योगेश कदम',
      position: 'मा. राज्यमंत्री, ग्रामविकास व पंचायतराज',
      image: '/person/योगेश कदम.png'
    }
  ];

  const localOfficials = [
    {
      name: 'सौ. सरस्वती शेषराव भोळे',
      position: 'सरपंच',
      image: '/person/dummy.png'
    },
    {
      name: 'श्री. जयेश प्रशांत नार्वेकर',
      position: 'उप-सरपंच',
      image: '/person/dummy.png'
    },
    {
      name: 'श्री. रामचंद्र माधव राजपूत',
      position: 'ग्रामपंचायत सचिव',
      image: '/person/dummy.png'
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <motion.section 
        className="hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="hero-slider">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            >
              <img 
                src={image} 
                alt={`Village ${index + 1}`}
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'cover',
                  position: 'absolute',
                  top: 0,
                  left: 0
                }}
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=1200&h=800&fit=crop';
                }}
              />
            </div>
          ))}
        </div>
        <div className="hero-content">
          <motion.h1
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            {t.welcome}
          </motion.h1>
          <motion.p
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            {t.welcomeDesc}
          </motion.p>
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.8, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link to="/contact" className="cta-button" style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
              <FaPhone /> आम्हाला संपर्क करा
            </Link>
          </motion.div>
        </div>
      </motion.section>

      {/* About Us + Image Collage Section */}
      <section className="services-section" style={{ background: '#f8f9fa', padding: '60px 0' }}>
        <div className="container">
          <div className="about-home-grid">
            {/* About Text */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="about-home-text"
            >
              <h2 className="section-title" style={{ textAlign: 'left', marginBottom: '1.5rem' }}>
                <span>आमच्याबद्दल</span>
              </h2>
              <p style={{ color: '#555', lineHeight: '1.9', marginBottom: '1.2rem', fontSize: '1.05rem' }}>
                नाशेरा हे महाराष्ट्रातील पालघर जिल्ह्याच्या मोखाडा तालुक्यात वसलेले एक सुंदर गाव आहे. 
                २०११ च्या जनगणनेनुसार गावाची एकूण लोकसंख्या १०८० आहे.
              </p>
              <p style={{ color: '#555', lineHeight: '1.9', marginBottom: '1.5rem', fontSize: '1.05rem' }}>
                हे गाव आपल्या समृद्ध आदिवासी संस्कृती आणि परंपरांसाठी ओळखले जाते. शेती हा गावकऱ्यांचा 
                मुख्य व्यवसाय असून गावात प्राथमिक शाळा व इतर आवश्यक सुविधा उपलब्ध आहेत.
              </p>
              <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', marginBottom: '2rem' }}>
                {[
                  { label: 'लोकसंख्या', value: '१०८०', icon: <FaUsers />, bg: 'linear-gradient(135deg, #1565c0, #1976d2)' },
                  { label: 'प्रभाग', value: '०५', icon: <FaBuilding />, bg: 'linear-gradient(135deg, #2e7d32, #388e3c)' },
                  { label: 'क्षेत्रफळ', value: '२.५ km²', icon: <FaMapMarkerAlt />, bg: 'linear-gradient(135deg, #e65100, #f57c00)' },
                ].map((item, i) => (
                  <motion.div key={i}
                    whileHover={{ scale: 1.08, y: -4 }}
                    transition={{ duration: 0.2 }}
                    style={{
                      background: item.bg,
                      color: 'white',
                      padding: '1rem 1.5rem',
                      borderRadius: '14px',
                      textAlign: 'center',
                      boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
                      minWidth: '100px',
                      cursor: 'default'
                    }}>
                    <div style={{ fontSize: '1.5rem', marginBottom: '4px' }}>{item.icon}</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: '800', lineHeight: 1 }}>{item.value}</div>
                    <div style={{ fontSize: '0.82rem', opacity: 0.9, marginTop: '4px' }}>{item.label}</div>
                  </motion.div>
                ))}
              </div>
              <button className="cta-button">अधिक वाचा</button>
            </motion.div>

            {/* Image Collage - 5 circles */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="about-home-collage"
            >
              <div className="circular-collage">
                {/* Top-left */}
                <motion.div className="circle-img circle-top-left"
                  initial={{ opacity: 0, scale: 0.4 }} whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}
                  whileHover={{ scale: 1.1 }}
                >
                  <img src="/img/3.jpeg" alt="Village 1" />
                </motion.div>
                {/* Top-right */}
                <motion.div className="circle-img circle-top-right"
                  initial={{ opacity: 0, scale: 0.4 }} whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.3 }}
                  whileHover={{ scale: 1.1 }}
                >
                  <img src="/img/9.jpeg" alt="Village 2" />
                </motion.div>
                {/* Bottom center */}
                <motion.div className="circle-img circle-bottom-center"
                  initial={{ opacity: 0, scale: 0.4 }} whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.5 }}
                  whileHover={{ scale: 1.1 }}
                >
                  <img src="/img/12.jpeg" alt="Village 3" />
                </motion.div>
                {/* Center badge */}
                <div className="collage-center-badge">
                  <span>नाशेरा</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Photo Gallery Strip */}
      <section className="services-section" style={{ background: 'white', padding: '40px 0' }}>
        <div className="container">
          <h2 className="section-title"><span>{t.photoGallery}</span></h2>
          <div className="auto-scroll-container">
            <div className="auto-scroll-images">
              {galleryImages.slice(0, 12).map((img, index) => (
                <img key={index} src={img} alt={`Gallery ${index + 1}`} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Village Statistics */}
      <section className="stats-section">
        <div className="container">
          <h2 className="section-title">गाव माहिती</h2>
          <div style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '2rem',
            marginBottom: '3rem'
          }}>
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                style={{
                  background: 'white',
                  padding: '1.5rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                  borderLeft: '4px solid #138808',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1.2rem',
                  transition: 'all 0.3s ease'
                }}
                whileHover={{ y: -5, boxShadow: '0 8px 25px rgba(0,0,0,0.15)' }}
              >
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.6rem',
                  color: '#138808',
                  flexShrink: 0,
                  transition: 'all 0.3s ease'
                }}>
                  {stat.icon}
                </div>
                <div>
                  <div style={{ fontSize: '2rem', fontWeight: '800', color: '#138808', lineHeight: 1.1 }}>
                    {stat.number}
                  </div>
                  <div style={{ color: '#555', fontSize: '1rem', fontWeight: '600', marginTop: '4px' }}>
                    {stat.label}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Nearby Villages */}
      <section className="services-section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">जवळची गावे</h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', 
            gap: '1.5rem',
            marginBottom: '3rem'
          }}>
            {nearbyVillages.map((village, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                style={{
                  background: 'white',
                  padding: '1.2rem 1.4rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  borderLeft: '4px solid #138808',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem'
                }}
                whileHover={{ y: -4, boxShadow: '0 8px 25px rgba(0,0,0,0.13)' }}
              >
                <div style={{
                  width: '48px', height: '48px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.3rem', color: '#138808', flexShrink: 0
                }}>
                  <FaMapMarkerAlt />
                </div>
                <h4 style={{ color: '#2c3e50', fontSize: '1.05rem', fontWeight: '700', margin: 0 }}>
                  {village.name}
                </h4>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Gram Panchayat Staff */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">ग्रामपंचायत कर्मचारी</h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
            gap: '1.5rem',
            marginBottom: '3rem'
          }}>
            {gramPanchayatStaff.map((staff, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                style={{
                  background: 'white',
                  padding: '1.3rem 1.5rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  borderLeft: '4px solid #138808',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem'
                }}
                whileHover={{ y: -4, boxShadow: '0 8px 25px rgba(0,0,0,0.13)' }}
              >
                <div style={{
                  width: '52px', height: '52px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.4rem', color: '#138808', flexShrink: 0
                }}>
                  {staff.icon}
                </div>
                <div>
                  <h4 style={{ color: '#2c3e50', fontSize: '1.05rem', fontWeight: '700', marginBottom: '3px' }}>{staff.name}</h4>
                  <p style={{ color: '#138808', fontSize: '0.9rem', fontWeight: '600', marginBottom: '6px' }}>{staff.position}</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#666', fontSize: '0.9rem' }}>
                    <FaPhone style={{ color: '#138808', fontSize: '0.8rem' }} /> {staff.phone}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Revenue and Other Coordination Staff */}
      <section className="services-section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">महसूल व इतर समन्वय कर्मचारी</h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '1.5rem',
            marginBottom: '3rem'
          }}>
            {revenueStaff.map((staff, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                style={{
                  background: 'white',
                  padding: '1.3rem 1.5rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  borderLeft: '4px solid #138808',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem'
                }}
                whileHover={{ y: -4, boxShadow: '0 8px 25px rgba(0,0,0,0.13)' }}
              >
                <div style={{
                  width: '52px', height: '52px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.4rem', color: '#138808', flexShrink: 0
                }}>
                  {staff.icon}
                </div>
                <div>
                  <h4 style={{ color: '#2c3e50', fontSize: '1.05rem', fontWeight: '700', marginBottom: '3px' }}>{staff.name}</h4>
                  <p style={{ color: '#138808', fontSize: '0.9rem', fontWeight: '600', marginBottom: '6px' }}>{staff.position}</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#666', fontSize: '0.9rem' }}>
                    <FaPhone style={{ color: '#138808', fontSize: '0.8rem' }} /> {staff.phone}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Health Department */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">आरोग्य विभाग</h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '1.5rem',
            marginBottom: '3rem'
          }}>
            {healthStaff.map((staff, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                style={{
                  background: 'white',
                  padding: '1.3rem 1.5rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  borderLeft: '4px solid #138808',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem'
                }}
                whileHover={{ y: -4, boxShadow: '0 8px 25px rgba(0,0,0,0.13)' }}
              >
                <div style={{
                  width: '52px', height: '52px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.4rem', color: '#138808', flexShrink: 0
                }}>
                  {staff.icon}
                </div>
                <div>
                  <h4 style={{ color: '#2c3e50', fontSize: '1.05rem', fontWeight: '700', marginBottom: '3px' }}>{staff.name}</h4>
                  <p style={{ color: '#138808', fontSize: '0.9rem', fontWeight: '600', marginBottom: '6px' }}>{staff.position}</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#666', fontSize: '0.9rem' }}>
                    <FaPhone style={{ color: '#138808', fontSize: '0.8rem' }} /> {staff.phone}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Education Department */}
      <section className="services-section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">शिक्षण विभाग</h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
            gap: '2rem',
            marginBottom: '3rem'
          }}>
            {educationData.map((school, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15 }}
                style={{
                  background: 'white',
                  padding: '1.5rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  borderLeft: '4px solid #138808'
                }}
                whileHover={{ y: -4, boxShadow: '0 8px 25px rgba(0,0,0,0.13)' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.2rem' }}>
                  <div style={{ width: '52px', height: '52px', background: 'rgba(19,136,8,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem', color: '#138808', flexShrink: 0 }}>
                    {school.icon}
                  </div>
                  <h4 style={{ color: '#2c3e50', fontSize: '1.05rem', fontWeight: '700', margin: 0 }}>{school.name}</h4>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.8rem', textAlign: 'center' }}>
                  <div style={{ background: 'rgba(19,136,8,0.08)', padding: '0.8rem', borderRadius: '8px' }}>
                    <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#138808' }}>{school.boys}</div>
                    <div style={{ color: '#666', fontSize: '0.85rem', fontWeight: '600' }}>मुले</div>
                  </div>
                  <div style={{ background: 'rgba(233,30,99,0.08)', padding: '0.8rem', borderRadius: '8px' }}>
                    <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#e91e63' }}>{school.girls}</div>
                    <div style={{ color: '#666', fontSize: '0.85rem', fontWeight: '600' }}>मुली</div>
                  </div>
                  <div style={{ background: 'rgba(46,125,50,0.1)', padding: '0.8rem', borderRadius: '8px' }}>
                    <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#2e7d32' }}>{school.total}</div>
                    <div style={{ color: '#666', fontSize: '0.85rem', fontWeight: '600' }}>एकूण</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Anganwadi Centers */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">अंगणवाडी केंद्रे</h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
            gap: '2rem',
            marginBottom: '3rem'
          }}>
            {anganwadiData.map((center, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15 }}
                style={{
                  background: 'white',
                  padding: '1.5rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  borderLeft: '4px solid #138808'
                }}
                whileHover={{ y: -4, boxShadow: '0 8px 25px rgba(0,0,0,0.13)' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.2rem' }}>
                  <div style={{ width: '52px', height: '52px', background: 'rgba(19,136,8,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem', color: '#138808', flexShrink: 0 }}>
                    {center.icon}
                  </div>
                  <h4 style={{ color: '#2c3e50', fontSize: '1.05rem', fontWeight: '700', margin: 0 }}>{center.name}</h4>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.8rem', textAlign: 'center' }}>
                  <div style={{ background: 'rgba(19,136,8,0.08)', padding: '0.8rem', borderRadius: '8px' }}>
                    <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#138808' }}>{center.boys}</div>
                    <div style={{ color: '#666', fontSize: '0.85rem', fontWeight: '600' }}>मुले</div>
                  </div>
                  <div style={{ background: 'rgba(233,30,99,0.08)', padding: '0.8rem', borderRadius: '8px' }}>
                    <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#e91e63' }}>{center.girls}</div>
                    <div style={{ color: '#666', fontSize: '0.85rem', fontWeight: '600' }}>मुली</div>
                  </div>
                  <div style={{ background: 'rgba(46,125,50,0.1)', padding: '0.8rem', borderRadius: '8px' }}>
                    <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#2e7d32' }}>{center.total}</div>
                    <div style={{ color: '#666', fontSize: '0.85rem', fontWeight: '600' }}>एकूण</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Self Help Groups */}
      <section className="services-section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">बचत गट</h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', 
            gap: '1rem',
            marginBottom: '3rem'
          }}>
            {selfHelpGroups.map((group, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.03 }}
                style={{
                  background: 'white',
                  padding: '0.9rem 0.8rem',
                  borderRadius: '10px',
                  textAlign: 'center',
                  boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
                  border: '1.5px solid rgba(19,136,8,0.15)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  justifyContent: 'center'
                }}
                whileHover={{ scale: 1.04, borderColor: '#138808' }}
              >
                <FaHandsHelping style={{ color: '#138808', fontSize: '0.95rem', flexShrink: 0 }} />
                <span style={{ color: '#2c3e50', fontSize: '0.92rem', fontWeight: '600', lineHeight: 1.3 }}>
                  {group}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Key Officials */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">प्रमुख अधिकारी</h2>

          {/* State Level Officials */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2.5rem' }}>
            {keyOfficials.map((official, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
                style={{
                  background: 'white',
                  borderRadius: '12px',
                  borderLeft: '4px solid #138808',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  padding: '1.3rem 1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1.2rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{
                  width: '64px', height: '64px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '3px solid rgba(19,136,8,0.3)',
                  flexShrink: 0
                }}>
                  <img
                    src={official.image}
                    alt={official.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={(e) => { e.target.src = '/person/dummy.png'; }}
                  />
                </div>
                <div>
                  <h4 style={{ color: '#2c3e50', fontSize: '1rem', fontWeight: '700', marginBottom: '4px' }}>
                    {official.name}
                  </h4>
                  <p style={{ color: '#138808', fontSize: '0.88rem', fontWeight: '600', margin: 0 }}>
                    {official.position}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Local Officials */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
            {localOfficials.map((official, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
                style={{
                  background: 'white',
                  borderRadius: '12px',
                  borderLeft: '4px solid #138808',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  padding: '1.3rem 1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1.2rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{
                  width: '64px', height: '64px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '3px solid rgba(19,136,8,0.3)',
                  flexShrink: 0
                }}>
                  <img
                    src={official.image}
                    alt={official.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={(e) => { e.target.src = '/person/dummy.png'; }}
                  />
                </div>
                <div>
                  <h4 style={{ color: '#2c3e50', fontSize: '1rem', fontWeight: '700', marginBottom: '4px' }}>
                    {official.name}
                  </h4>
                  <p style={{ color: '#138808', fontSize: '0.88rem', fontWeight: '600', margin: 0 }}>
                    {official.position}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* महत्त्वाचे दुवे व सेवा */}
      <section style={{ background: 'linear-gradient(135deg, #0f2027 0%, #1a3a2a 50%, #0f2027 100%)', padding: '80px 0', color: 'white' }}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            style={{ textAlign: 'center', marginBottom: '3.5rem' }}
          >
            <h2 style={{ fontSize: '2.2rem', fontWeight: 800, color: '#ffffff', marginBottom: '0.8rem', letterSpacing: '1px' }}>
              महत्त्वाचे दुवे व सेवा
            </h2>
            <div style={{ width: '70px', height: '4px', background: 'linear-gradient(90deg, #138808, #66bb6a)', borderRadius: '2px', margin: '0 auto 1rem' }} />
            <p style={{ color: '#90caf9', fontSize: '1.05rem' }}>
              नागरिक सेवा व शासकीय पोर्टल्सचा त्वरित प्रवेश
            </p>
          </motion.div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
            {[
              { icon: <FaMoneyBillWave />, title: 'कर माहिती', desc: 'पोर्टलवर भरावयाचा कर जाणून घ्या', gradient: 'linear-gradient(135deg, #138808 0%, #2e7d32 100%)', glow: 'rgba(19,136,8,0.35)', delay: 0 },
              { icon: <FaFileAlt />, title: 'नागरिक सेवा', desc: 'जन्म, मृत्यू, विवाह नोंदणी इ.', gradient: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)', glow: 'rgba(21,101,192,0.35)', delay: 0.12 },
              { icon: <FaBuilding />, title: 'जॉब कार्ड यादी', desc: 'मनरेगा लाभार्थी स्थिती', gradient: 'linear-gradient(135deg, #6a1b9a 0%, #4a148c 100%)', glow: 'rgba(106,27,154,0.35)', delay: 0.24 },
            ].map((card, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 50, scale: 0.92 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: card.delay, ease: 'easeOut' }}
                whileHover={{ y: -10, scale: 1.03 }}
                style={{
                  background: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '18px',
                  padding: '2.5rem 2rem',
                  textAlign: 'center',
                  backdropFilter: 'blur(12px)',
                  cursor: 'pointer',
                  boxShadow: `0 8px 32px ${card.glow}`
                }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = `0 20px 50px ${card.glow}`}
                onMouseLeave={e => e.currentTarget.style.boxShadow = `0 8px 32px ${card.glow}`}
              >
                <motion.div
                  whileHover={{ rotate: 10, scale: 1.15 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                  style={{
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    width: '80px', height: '80px', borderRadius: '50%',
                    background: card.gradient, fontSize: '2rem', color: 'white',
                    marginBottom: '1.5rem', boxShadow: `0 6px 20px ${card.glow}`
                  }}
                >
                  {card.icon}
                </motion.div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#ffffff', marginBottom: '0.7rem' }}>{card.title}</h3>
                <p style={{ color: '#b0bec5', fontSize: '0.97rem', lineHeight: 1.6 }}>{card.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Government Portals Logos Slider */}
      <section className="services-section" style={{ background: '#f8f9fa', padding: '50px 0' }}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            style={{ textAlign: 'center', marginBottom: '2.5rem' }}
          >
            <h2 className="section-title"><span>शासकीय पोर्टल्स</span></h2>
            <p style={{ color: '#666', fontSize: '1rem', marginTop: '0.5rem' }}>
              महत्त्वाच्या शासकीय संकेतस्थळांशी त्वरित जोडणी
            </p>
          </motion.div>
          <div className="gov-logos-container">
            <div className="gov-logos-track">
              {[...Array.from({ length: 13 }, (_, i) => i === 3 ? `/gov_logos/4.jpg` : `/gov_logos/${i + 1}.png`),
                ...Array.from({ length: 13 }, (_, i) => i === 3 ? `/gov_logos/4.jpg` : `/gov_logos/${i + 1}.png`)
              ].map((logo, index) => (
                <div key={index} className="gov-logo-card">
                  <img
                    src={logo}
                    alt={`शासकीय पोर्टल ${(index % 13) + 1}`}
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <FAQ />
    </div>
  );
}

export default Home;
